import { getNewsList } from "../Api";
export default {
    state: {
        news: [], // Массив новостей
        currentPage: 0, // Текущая страница
        totalPages: 0, // Общее количество страниц
        newsLoading: false, // Состояние загрузки
        total: null,
    },
    mutations: {
        SET_NEWS(state, news) {
            state.news = [...state.news, ...news];
        },
        SET_CURRENT_PAGE(state, page) {
            state.currentPage = page;
        },
        SET_TOTAL_PAGES(state, totalPages) {
            state.totalPages = totalPages;
        },
        SET_LOADING(state, loading) {
            state.newsLoading = loading;
        },                                                                            
        SET_TOTAL_NEWS(state, total) {
            state.total = total;
        },
    },                                       
    actions: {
        async fetchNews({ commit, state }) {
            if (state.news.length && state.news.length === state.total) {
                return;
            }
            commit("SET_LOADING", true);
            commit("SET_CURRENT_PAGE", state.currentPage + 1);
            try {
                const response = await getNewsList({ page: state.currentPage });
                commit("SET_NEWS", response.data);
                commit("SET_TOTAL_PAGES", response.pagination.last_page);
                commit("SET_TOTAL_NEWS", response.pagination.total);
            } catch (error) {
                console.error("Error fetching news:", error);
            } finally {
                commit("SET_LOADING", false);
            }
        },
    },
    getters: {
        news: (state) => state.news,
        currentPage: (state) => state.currentPage,
        totalPages: (state) => state.totalPages,
        newsLoading: (state) => state.newsLoading,
    },
};
